import { AlertModal, Box } from '@modusign/design-system';
import { useDispatch } from 'react-redux';

import { modalClose } from '@app/store/modal/actions';

const AccountSuspendedModal = () => {
  const dispatch = useDispatch();

  const handleConfirmModal = () => {
    dispatch(modalClose());
  };

  return (
    <AlertModal
      isOpen
      maxWidth="xs"
      title="이용 중지된 계정"
      variant="warning"
      onClose={handleConfirmModal}
    >
      부적절한 서비스 이용이 확인되어 중지된 계정입니다.
      <Box as="br" />
      고객센터를 통해서 문의해 주세요.
    </AlertModal>
  );
};

export default AccountSuspendedModal;
